import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from "react";
import { buildUpgradeUrl } from "@zapier/checkout";
import { Price } from "@zapier/currency";
import { Button, Link } from "@zapier/design-system";
import { TaskHistoryButton, UpgradeButton, } from "@zapier/upsells/esm/components";
const views = {
    ["DEFAULT"]: ({ currency, currentPlan, destinationPlan, }) => ({
        bodyText: (_jsxs(Fragment, { children: ["Keep your Zaps running by upgrading your plan with more", " ", _jsx(Link, { href: "/help/manage/history/learn-about-tasks-in-zapier", children: "tasks" }), ". Get access to ", Number(destinationPlan.tasks).toLocaleString(), " tasks with the ", destinationPlan.type, " plan for", " ", _jsx(Price, { currency: currency, children: destinationPlan.interval === "year"
                        ? destinationPlan.amount / 12
                        : destinationPlan.amount }), " ", "per month."] })),
        buttons: [
            _jsx(TaskHistoryButton, {}, "DEFAULT-task-history-button"),
            _jsx(UpgradeButton, { href: buildUpgradeUrl(null, destinationPlan.name, currentPlan.interval) }, "DEFAULT-upgrade-button"),
        ],
        type: "DEFAULT",
    }),
    ["DEFAULT_AUTO_UPGRADE"]: ({ autoUpgradeToPlan, }) => ({
        bodyText: (_jsxs(Fragment, { children: ["Because you've opted into the", " ", _jsx(Link, { href: "/l/automatic-task-upgrades", children: "automatic task upgrade" }), " ", "feature, if you reach 100% of your task limit, you will be upgraded to the ", autoUpgradeToPlan.type, " plan with", " ", Number(autoUpgradeToPlan.tasks).toLocaleString(), " tasks.", " ", _jsx("strong", { children: "No action from you is required." })] })),
        buttons: [
            _jsx(TaskHistoryButton, {}, "DEFAULT_AUTO_UPGRADE-upgrade-button"),
            _jsx(Button, { color: "primary", href: "/app/settings/billing", children: "Manage setting" }, "manage-auto-upgrade"),
        ],
        type: "DEFAULT_AUTO_UPGRADE",
    }),
};
export const getActiveView = ({ autoUpgradeToPlan, currency, currentPlan, destinationPlan, isAutoUpgradeEnabled, }) => {
    if (isAutoUpgradeEnabled && autoUpgradeToPlan) {
        return views.DEFAULT_AUTO_UPGRADE({
            autoUpgradeToPlan,
        });
    }
    return views.DEFAULT({
        currency,
        currentPlan,
        destinationPlan,
    });
};

// @zapier/upsells@8.0.3 (1de7a616e)
